import api from "@/api";

/** @type {import("vuex").Module} */
export const metatags = {
    namespaced: true,

    state: {
        /** @type {import("./inits").CommonMetatagVariable[]} */
        variables: [],
    },

    getters: {
        variables_object(state) {
            return state.variables.reduce((object, { code, text }) => ({ ...object, [code]: text }), {});
        },
    },

    mutations: {
        setVariables(state, payload) {
            state.variables = payload;
        },
    },

    actions: {
        async getVariables({ commit }) {
            const { setting } = await api.console.setting.get();
            commit("setVariables", setting?.metatag?.variables);
        },
        async setVariables({ dispatch }, items) {
            const {
                setting: { metatag },
            } = await api.console.setting.get();
            metatag.variables = items;

            await api.console.setting.put({ metatag });

            await dispatch("getVariables");
        },
    },
};

export default metatags;
